// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchTrigger_root__RDFcq","icon":"SearchTrigger_icon__2Xzj_","rotation":"SearchTrigger_rotation__C0U16"};